"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsCache = void 0;
/**
 * Provides caching for events IDs.
 */
class EventsCache {
    driveCache;
    /**
     * Locally cached events data to avoid unnecessary reads from the cache.
     * Data about last event ID or interval might be accessed often by events
     * managers.
     */
    events;
    constructor(driveCache) {
        this.driveCache = driveCache;
        this.driveCache = driveCache;
    }
    async setLastEventId(volumeIdOrCore, eventsData) {
        const events = await this.getEvents();
        events[volumeIdOrCore] = eventsData;
        await this.cacheEvents(events);
    }
    async getLastEventId(volumeIdOrCore) {
        const events = await this.getEvents();
        if (events[volumeIdOrCore]) {
            return events[volumeIdOrCore].lastEventId;
        }
    }
    async getPollingIntervalInSeconds(volumeIdOrCore) {
        const events = await this.getEvents();
        if (events[volumeIdOrCore]) {
            return events[volumeIdOrCore].pollingIntervalInSeconds;
        }
    }
    async isOwnVolume(volumeIdOrCore) {
        const events = await this.getEvents();
        if (events[volumeIdOrCore]) {
            return events[volumeIdOrCore].isOwnVolume;
        }
    }
    async getSubscribedVolumeIds() {
        const events = await this.getEvents();
        return Object.keys(events).filter((volumeIdOrCore) => volumeIdOrCore !== 'core');
    }
    async getEvents() {
        if (!this.events) {
            this.events = await this.getCachedEvents();
        }
        return this.events;
    }
    async getCachedEvents() {
        try {
            const events = await this.driveCache.getEntity('events');
            return JSON.parse(events);
        }
        catch { }
        ;
        return {};
    }
    async cacheEvents(events) {
        this.events = events;
        await this.driveCache.setEntity('events', JSON.stringify(events));
    }
}
exports.EventsCache = EventsCache;
//# sourceMappingURL=cache.js.map